// extracted by mini-css-extract-plugin
export default {"BtnContainer":"SimpleBtn_BtnContainer__p-tV8","Left":"SimpleBtn_Left__MPXpc","Center":"SimpleBtn_Center__vt5dh","Right":"SimpleBtn_Right__3RmDT","Btn":"SimpleBtn_Btn__1HAsg"};